import { AritoCustomInputTable as InputTable } from '@/components/custom/erp';
import InputTableActionBar from './DetailTableActionBar';
import { getInputTableColumns } from './cols';
import type { FormMode } from '@/types/form';

interface DetailTableProps {
  mode: FormMode;
  rows: any[];
  selectedRowUuid?: string | null;
  onRowClick?: (params: any) => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onView?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onRefresh?: () => void;
  onDownloadTemplate?: () => void;
  onImportExcel?: () => void;
}

const DetailTableTab: React.FC<DetailTableProps> = ({
  mode,
  rows,
  selectedRowUuid,
  onRowClick,
  onAdd,
  onDelete,
  onCopy,
  onEdit,
  onView,
  onRefresh,
  onDownloadTemplate,
  onImportExcel
}) => {
  return (
    <InputTable
      rows={rows}
      className='h-full flex-1'
      onRowClick={onRowClick}
      selectedRowId={selectedRowUuid || undefined}
      columns={getInputTableColumns()}
      getRowId={(row: any) => row?.uuid || ''}
      actionButtons={
        <InputTableActionBar
          mode={mode}
          handleAdd={onAdd}
          handleDelete={onDelete}
          handleCopy={onCopy}
          handleEdit={onEdit}
          handleView={onView}
          handleRefresh={onRefresh}
          handleDownloadTemplate={onDownloadTemplate}
          handleImportExcel={onImportExcel}
        />
      }
    />
  );
};

export default DetailTableTab;
